<app-app-holder>
    <app-navbar></app-navbar>

    <app-sidebar>
        <app-settings-subnav></app-settings-subnav>
    </app-sidebar>

    <app-content>
        <div class="app__title">
            <h1>General settings</h1>
        </div>

        <div *ngIf="generalSettings$ | async; else loading">
            <div
                (click)="openUpdateDaysPerMonthModal()"
                class="list__item pointer">
                <div class="list__item__icon">
                    <i class="las la-calendar-day color--grey"></i>
                </div>
                <div class="list__item__content">
                    <strong>Change default days per month</strong>
                    <small>This will be used in financial calculations</small>
                </div>
            </div>

            <div
                (click)="openUpdateHolidayDaysModal()"
                class="list__item pointer">
                <div class="list__item__icon">
                    <i class="las la-business-time color--grey"></i>
                </div>
                <div class="list__item__content">
                    <strong>Change holiday days this for this year</strong>
                    <small>These days will be used in for example the planning</small>
                </div>
            </div>

            <div
                (click)="openLogbookCategoriesModal()"
                class="list__item pointer">
                <ng-container *ngIf="logCategories$ | async; else loading">
                    <div class="list__item__icon">
                        <i class="las la-book color--grey"></i>
                    </div>
                    <div class="list__item__content">
                        <strong>Change categories for the logbook</strong>
                    </div>
                </ng-container>
            </div>

            <div class="list__item">
                <div class="list__item__icon">
                    <i class="las la-calendar-check color--grey"></i>
                </div>
                <div class="list__item__content">
                    <strong>Include current month in financial overviews</strong>
                    <small>
                        When off (default), the financial overviews and the per-employee/per-project totals
                        only count complete months up to and including the previous month.
                        When on, the running current month is included as well.
                    </small>
                    <div style="margin-top: 0.5rem;">
                        <label class="checkbox">
                            <input
                                type="checkbox"
                                [checked]="!!generalSettings?.financialsIncludeCurrentMonth"
                                (change)="toggleFinancialsIncludeCurrentMonth($any($event.target).checked)" />
                            Include current month
                        </label>
                    </div>
                </div>
            </div>

            <div class="list__item">
                <div class="list__item__icon">
                    <i class="las la-envelope color--grey"></i>
                </div>
                <div class="list__item__content postmark-token">
                    <strong>Postmark API Token</strong>
                    <small>Configure the Postmark API token used for sending all emails</small>
                    <div class="postmark-token__controls">
                        <div class="postmark-token__input-wrap">
                            <input
                                [type]="showPostmarkToken ? 'text' : 'password'"
                                class="postmark-token__input"
                                [(ngModel)]="postmarkApiToken"
                                data-testid="postmark-token-input"
                                [placeholder]="postmarkPlaceholder()" />
                            <button
                                class="button button--outline button--small button--icon postmark-token__toggle"
                                type="button"
                                (click)="togglePostmarkTokenVisibility()">
                                <i [class]="showPostmarkToken ? 'las la-eye-slash' : 'las la-eye'"></i>
                            </button>
                        </div>
                        <button
                            appGuardDoubleClick
                            class="button button--primary button--small"
                            type="button"
                            (click)="savePostmarkApiToken()">
                            Save token
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <ng-template #loading>
            <app-loading-message></app-loading-message>
        </ng-template>
    </app-content>
</app-app-holder>
